export const environment = {
    production: true,
    yandexMetrikaCounterConfigs: [
        {
            id: 93553080,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
        },
        {
            id: 94897469,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
        },
        {
            id: 94897578,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
        },
    ],
};
